module.exports = __webpack_public_path__ + "static/media/tablet_investments.f71d61dd.jpg";